export default function Testimonials() {
  const testimonials = [
    {
      name: 'Priya Sharma',
      role: 'Mehndi Artist, Mumbai',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Indian%20mehndi%20artist%20woman%20portrait%2C%20confident%20smile%2C%20traditional%20attire%2C%20cultural%20beauty%20professional%2C%20studio%20photography%2C%20simple%20clean%20white%20background&width=400&height=400&seq=test1&orientation=squarish',
      text: 'I have been using Pavitra Rishta henna powder for the past 2 years. The quality is consistently excellent and my clients love the rich color and smooth texture. Highly recommended for professional mehndi artists!',
      rating: 5
    },
    {
      name: 'Rajesh Kumar',
      role: 'Wholesale Distributor, Delhi',
      image: 'https://readdy.ai/api/search-image?query=Indian%20businessman%20portrait%2C%20professional%20attire%2C%20confident%20expression%2C%20wholesale%20business%20owner%2C%20studio%20photography%2C%20simple%20clean%20white%20background&width=400&height=400&seq=test2&orientation=squarish',
      text: 'Pavitra Rishta provides the best quality Sojat henna at competitive wholesale prices. Their packaging is excellent and delivery is always on time. Great partner for bulk orders!',
      rating: 5
    },
    {
      name: 'Anjali Patel',
      role: 'Online Seller, Gujarat',
      image: 'https://readdy.ai/api/search-image?query=Young%20Indian%20woman%20entrepreneur%20portrait%2C%20modern%20professional%2C%20online%20business%20owner%2C%20confident%20smile%2C%20studio%20photography%2C%20simple%20clean%20white%20background&width=400&height=400&seq=test3&orientation=squarish',
      text: 'As an online seller, product quality is crucial for my business. Pavitra Rishta never disappoints. The fine mesh quality and natural color make it a bestseller in my store. Excellent product!',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Trusted by mehndi artists, distributors, and resellers across India
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-green-50 to-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2"
            >
              {/* Rating */}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-sm text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Client Info */}
              <div className="flex items-center">
                <div className="w-14 h-14 rounded-full overflow-hidden mr-4 flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="text-base font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}